import en from 'src/utils/locale/en';

export default {
  ...en,

  appName: 'Creator',

  appbar: {
    userMenu: {
      logout: 'Log out',
    },
    popupLogout: {
      title: 'Logout',
      content: 'Are you sure you want to log out?',
      approve: 'Log out',
      reject: 'Cancel',
    },
    support: 'Contact us',
    settings: 'Settings',
    projects: 'My Projects',
  },

  settings: {
    facebookAdAccount: {
      label:
        "Please select the Facebook ad account that best represents your ads' history. It will only be used for calibrating our recommendations:",
      placeholder: 'Select your account',
    },
    facebookPage: {
      label: 'Please select the Facebook page you will be using:',
      placeholder: 'Select your page',
    },
    linkedinOrganization: {
      label: 'Please select the LinkedIn page you will be using:',
      placeholder: 'Select your page',
    },
    privacyLink: {
      label: 'Please add your privacy policy link here:',
      placeholder: 'Add your link',
    },
    destinationUrl: {
      label: 'Please add the relevant landing page:',
      placeholder: 'Add your link',
    },
  },

  SignUpPage: {
    email: {
      label: 'Email',
    },
    password: {
      label: 'Password',
    },
    submit: 'Sign up',
  },

  SignInPage: {
    form: {
      email: {
        label: 'Email',
      },
      password: {
        label: 'Password',
      },
    },
    submit: 'Log in',
    forgotPassword: {
      message: '',
      button: 'Forgot password?',
    },
  },

  ResetPasswordPage: {
    emailPanel: {
      title: 'Happens to the best of us. \n Enter your email and we’ll send you a reset link.',
      email: {
        label: 'Email',
      },
      submit: 'Reset password',
      returnToLogin: 'Return to login',
    },
    sentPanel: {
      title: 'Done and done',
      subtitle: 'We’ve sent you an email with a password reset link.',
      resentMessage: 'We’ve sent you another email. Please check your inbox.',
    },
    passwordPanel: {
      password: {
        label: 'New password',
      },
      passwordConfirmation: {
        label: 'Confirm new password',
      },
      dontEqualMessage: 'Passwords don’t match',
      submit: 'Reset password',
      returnToLogin: 'Return to login',
    },
    finishPanel: {
      title: 'Password updated',
      subtitle: 'You’re all set.',
      returnToLogin: 'Return to login',
    },
  },

  SettingsPage: {
    invite: {
      title: 'Invite User',
      email: {
        label: 'Email address',
        placeholder: 'Michael@email.com',
      },
      name: {
        label: 'Name (optional)',
        placeholder: 'Michael Scott',
      },
      send: 'Send invitation',
      cancel: 'Cancel',
    },
    inviteSuccess: {
      title: 'Invite User',
      content: 'Invitation was successfully sent!\nThe user will be added after sign up.',
    },
  },

  AnnotationSimilar: {
    title: 'These words have increased engagement for other related creatives:',
  },

  NormalizationStatusBar: {
    loading: {
      title: 'The system is analyzing your Facebook ad accounts.',
      subtitle:
        'Once the process is finished, you may choose the most relevant ad account for this project.',
    },
    finished: {
      title: 'The system has finished analyzing your Facebook ad accounts.',
      subtitle: 'Improve your score accuracy by selecting the most relevant $LINK.',
      link: 'ad account',
    },
  },

  DemoPage: {
    PanelWelcome: {
      title: 'Welcome to\nAnyword beta extension',
      subtitle:
        'Let’s get started with a quick tour that will help you get the most out of extension.' +
        '\n\n' +
        'It won’t take long.',
      buttonStart: 'Get Started',
      buttonSkip: 'Skip tour',
    },
    PanelPlatforms: {
      title: 'That’s it, you’re good to go',
      subtitle: 'Click on one of the links below and start enhancing your copywriting.',
      buttonSkip: 'Take the tour again',
    },
  },

  InfoLinks: {
    termsOfService: 'Terms of Service',
    privacyPolicy: 'Privacy Policy',
    contactUs: 'Contact Us',
  },

  SignUpAgreement: {
    agreementPart1: 'By signing up, you agree to the ',
    agreementPart2: ' and ',
  },

  PanelCheckSpam: {
    didntReceive: "Didn't receive an email?",
    checkSpam: 'Check your spam folder',
    resendEmail: 'Resend email',
    contactSupport: 'Contact support',
  },

  validation: {
    incorrectURL: 'Specified URL seems to have an incorrect value. Please, re-check the URL',
  },
};
